<template>
<div>
     <v-data-table :search="search" v-if="!isLoading" :single-select="singleSelect" v-model="selected" show-select :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }" :headers="headers" class="elevation-1 mt-0 px-5" :items="quastion" :height="inerHeight">

          <template v-slot:item.isShow="{ item }">
               <v-chip color="green lighten-0" dark v-if="item.isShow == 1">
                    <v-icon>mdi-eye</v-icon>
               </v-chip>
               <v-chip color="red lighten-1" dark v-else>
                    <v-icon>mdi-eye-off</v-icon>
               </v-chip>
          </template>

          <template v-slot:top>
             
               <v-toolbar flat color="">
                    <v-toolbar-title style="font-size: 25px">{{$t('question') + ':'}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                 <v-autocomplete class="ma-4 mt-11" :items="isShow" clearable dense v-model="filters.show" :label="$t('showQuest')" :item-text="localLang=='fr' ? 'showQuest' : 'showQuestAr'" item-value="id" outlined></v-autocomplete>
              
                <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" offset-y min-width="240px">
                      <template v-slot:activator="{ on }">
                            <v-text-field class="ma-4" @click:clear="clirtext" dense hide-details outlined v-model="dateRangeText" :label="$t('dateDF')" clearable readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="filters.created_at" range></v-date-picker>
                  </v-menu>

                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn @click="deleteMulti" v-on="on" class="ma-2" hide-details tile color="red">
                                   <v-icon color="white" size="30">mdi-delete-sweep</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('deleteMulti') }}</span>
                    </v-tooltip>
                    

               </v-toolbar>
          </template>

          <template v-slot:item.created_at="{ item }">
               <v-chip dark color="grey lighten-1">{{ item.created_at | moment  }}</v-chip>
          </template>
          <template v-slot:item.response="{ item }">
               <span dark color="grey lighten-1">{{ item.response.substring(0,60)  }}...</span>
          </template>
          <template v-slot:item.question="{ item }">
               <span dark color="grey lighten-1">{{ item.question.substring(0,60)  }}...</span>
          </template>

          <template v-slot:item.show="{ item }">
               <v-chip dark v-if="item.show == 0" color="red lighten-1">{{ $t('non')  }}</v-chip>
               <v-chip dark v-if="item.show == 1" color="green lighten-1">{{ $t('oui')  }}</v-chip>
          </template>

          <template v-slot:item.action="{ item }"> 
               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="green" @click="updateResponse(item)">
                              <v-icon size="30"> mdi-segment </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('response') }}</span>
               </v-tooltip>

               <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                         <v-btn v-on="on" icon color="red" @click="removeItem(item)">
                              <v-icon size=30>mdi-delete-outline </v-icon>
                         </v-btn>
                    </template>
                    <span>{{ $t('supprimer') }}</span>
               </v-tooltip>

          </template>
 
     </v-data-table>
     <v-dialog v-model="dialog" persistent max-width="900">
          <v-card>
               <v-card-title class="headline">
                    {{  $t('addResponse')  }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="red" outlined icon @click="close()" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>
               </v-card-title>
               <v-card-text>
                    <v-row>
                         <v-col cols="12" lg="12" md="12" sm="12">
                              <v-textarea outlined rows="3" hide-details v-model="form.question" clearable :label="$t('question')"></v-textarea>
                         </v-col>
                         <v-col cols="12" lg="6" md="6" sm="12">
                              <v-textarea outlined rows="3" v-model="form.response" hide-details clearable :label="$t('response')"></v-textarea>
                         </v-col>
                         <v-col cols="12" lg="6" md="6" sm="12">
                              <v-textarea outlined rows="3" v-model="form.responseAr" hide-details clearable :label="$t('responseAr')"></v-textarea>
                         </v-col>
                         <v-col cols="12">
                              <span>{{ $t('showResponse') }}</span>
                              <v-radio-group hide-details v-model="form.show" row>
                                   <v-radio :label="$t('non')" value="0"></v-radio>
                                   <v-radio :label="$t('oui')" value="1"></v-radio>
                              </v-radio-group>
                         </v-col>
                    </v-row>
               </v-card-text>
               <v-card-actions hide-details>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" :disabled="isLoad" text @click="saveQuestion">{{   $t('save') }}</v-btn>
               </v-card-actions>
          </v-card>
     </v-dialog>
</div>
</template>

<script>
export default {
     data: () => ({
            menu2: false,
            isLoad: false,
            isShow: [
              {
                  id: 1,
                  showQuest: 'Oui',
                  showQuestAr: 'نعم',
               },
               {
                  id: 0,
                  showQuest: 'Non',
                  showQuestAr: 'لا',
               }
          ],
          inerHeight: window.innerHeight - 260,
          selected: [],
          search: '',
          filters: {
            show:'',
            created_at: [],
          },
          form: [],
          singleSelect: false,
          column: null,
          row: null,
          forUpdate: false,
          dialog: false,
          headers: [{
                    text: localStorage.getItem('lang') == 'fr' ? 'Le nom' : 'الإسم',
                    value: 'nom',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'E-mail' : 'البريد الإلكتروني',
                    value: 'email',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Téléphone' : 'الهاتف',
                    value: 'telephone',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Question' : 'السؤال',
                    value: 'question',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Réponse' : 'الإجابة',
                    value: 'response',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Affichez la question' : 'إظهار السؤال',
                    value: 'show',
                    align: 'center',
                    sortable: false
               },
                {
                    text: localStorage.getItem('lang') == 'fr' ? 'A été ouvert' : 'تم فتحها',
                    value: 'isShow',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Date' : 'بتاريخ',
                    value: 'created_at',
                    align: 'center',
                    sortable: false
               },
               {
                    text: localStorage.getItem('lang') == 'fr' ? 'Action' : 'الحدث',
                    value: 'action',
                    align: 'center',
                    sortable: false
               },
          ],
     }),

     methods: {
        clirtext(e) {
               this.filters.created_at = ['', '']
          },
          init() {
               this.form = {
                    type:1,
                    question: '',
                    response: '',
                    responseAr: '',
                    show: "0",
               }
          }, 
          removeItem(data) {
               this.$store.dispatch('deleteQuestion', {
                    data: JSON.stringify(data)
               })
               this.$store.dispatch('getQuastion')
          },
          deleteMulti() {
            this.$store.dispatch('deleteQuestion', {
                    data: JSON.stringify(this.selected)
               })
               this.$store.dispatch('getQuastion')
          },
          updateResponse(data) { 
               this.form = data 
               this.form.show = data.show == 0 ? "0" : "1"
               this.form.type = 1
               this.dialog = true
          },
          saveQuestion() {
               this.isLoad = true
               var url = "getQuastion/addQuastion"
               var commit = "getQuastion"

               this.$Register({data: JSON.stringify(this.form)}, url, commit).then((r) => {
                    this.dialog = false
                    this.isLoad = false
               }).catch(() => {
                    this.isLoad = false
               })
          },
          close() {
               this.dialog = false
          }
     },

     computed: {
          dateRangeText() {
               return this.filters.created_at.join(' ~ ')
          },
         
          
          quastion() { 
               return new this.$MultiFilter(this.$store.state.quastion, this.filters).filterData()
          },
          
     },
     created() { 
          this.init()
          Fire.$on('search',(search) => {
               this.search = search
          } )
     }
}
</script>

<style>

</style>
